import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  waterTypes: [],
  waterSubTypesCatalog: {},
};

export const WaterTypesSlice = createSlice({
  name: "WaterCatalog",
  initialState,
  reducers: {
    updateWatersTypesData: (state, action) => {
      state.waterTypes = action.payload;
    },
    updateWaterSubTypesData: (state, action) => {
      state.waterSubTypesCatalog = action.payload;
    },
  },
});

export const { updateWatersTypesData, updateWaterSubTypesData } = WaterTypesSlice.actions;

export default WaterTypesSlice.reducer;
